// Misc Untilities and functions
let jp = require("jsonpath");
// Capture the installed engine before exposing it to tenant customizations.
const translationPaths = createFastPaths(jp);
window.jp = jp; // See jsonpath docs for filter params @ https://github.com/json-path/JsonPath

// Preserve the legacy serialized-text matches (including string values), their
// first-occurrence order, and ASCII-only prefixes. Only _calc permits spaces.
// Searching literal suffixes avoids regex backtracking over long inert values.
function discoverTranslationKeys(text, suffix) {
  const marker = '_' + suffix + '"';
  const keys = new Set();
  for (let tail = text.indexOf(marker); tail !== -1; tail = text.indexOf(marker, tail + marker.length)) {
    let start = tail;
    while (start > 0) {
      const code = text.charCodeAt(start - 1);
      const word = code >= 48 && code <= 57 || code >= 65 && code <= 90 ||
        code >= 97 && code <= 122 || code === 95;
      if (!word && !(suffix === 'calc' && code === 32)) break;
      start--;
    }
    if (start < tail) keys.add(text.slice(start, tail + marker.length - 1));
  }
  return Array.from(keys);
}

// Compatible with jsonpath 1.1.1. Revalidate private dispatch on upgrades.
// Avoid copying nonmatching paths, but retain all observable property reads.
function createFastPaths(engine) {
  // Initialize against the installed, unmodified engine before tenant code.
  // Keep its assertions, parser, nodes and dispatcher; specialize only the
  // known descendant handler. Never patch public methods, even temporarily.
  const nativePaths = engine.paths;
  const nativeNodes = engine.nodes;
  const nativeParser = engine.parser;
  const nativeParse = nativeParser.parse;
  const nativeHandlers = engine.handlers;
  const nativeResolve = nativeHandlers.resolve;
  const nativeTraverse = nativeHandlers.traverse;
  const nativeDescendant = nativeHandlers._fns['member-descendant-identifier'];
  const nativeKeys = Object.keys;

  function traverse(handlers, partial, key, count) {
    const results = [];
    const path = partial.path.slice();
    function walk(value) {
      if (Array.isArray(value)) {
        value.forEach((element, index) => {
          if (results.length >= count) return;
          if (index == key) results.push({ path: path.concat(index), value: element });
        });
        value.forEach((element, index) => {
          if (results.length >= count) return;
          path.push(index); walk(element); path.pop();
        });
      } else if (value && !(value instanceof Array) && value instanceof Object) {
        handlers.keys(value).forEach(name => {
          if (results.length >= count) return;
          void value[name];
          if (name == key) results.push({ path: path.concat(name), value: value[name] });
        });
        // Resolve keys again, including a customization installed by a getter.
        // Do not restart traversal and duplicate observable getter effects.
        handlers.keys(value).forEach(name => {
          if (results.length >= count) return;
          path.push(name); walk(value[name]); path.pop();
        });
      }
    }
    walk(partial.value);
    return results;
  }

  return function fastPaths(data, filter, count) {
    if (engine.paths !== nativePaths || typeof filter !== 'string' ||
        count !== undefined && typeof count !== 'number' ||
        !/^\$\.\.(?:\['[a-zA-Z0-9_ ]+'\]|[a-zA-Z_$][\w$]*)$/.test(filter) &&
        !/^\$\.pages\.\.[a-zA-Z_$][\w$]*$/.test(filter)) {
      return engine.paths.apply(engine, arguments);
    }
    // These private receivers forward each stage at the original time. A root
    // Proxy may change nodes/parser/handlers during the native assertions.
    return nativePaths.call({ nodes(object, expression, limit) {
      const nodes = engine.nodes;
      if (nodes !== nativeNodes) return nodes.call(engine, object, expression, limit);
      let standardParser = false;
      return nativeNodes.call({
        get parser() {
          const current = engine.parser;
          standardParser = current === nativeParser && current.parse === nativeParse;
          return current;
        },
        get handlers() {
          const handlers = engine.handlers;
          if (!standardParser || handlers !== nativeHandlers) return handlers;
          return { resolve(component) {
            const resolve = handlers.resolve;
            if (resolve !== nativeResolve) return resolve.call(handlers, component);
            const resolved = resolve.call(handlers, component);
            const kind = [component.operation, component.scope, component.expression.type].join('-');
            if (!['member-descendant-identifier', 'subscript-descendant-string_literal'].includes(kind) ||
                handlers.traverse !== nativeTraverse || handlers.keys !== nativeKeys ||
                handlers._fns[kind] !== nativeDescendant) return resolved;
            return (part, partial, maximum) => traverse(handlers, partial, part.expression.value, maximum);
          } };
        }
      }, object, expression, limit);
    } }, data, filter, count);
  };
}

const TranslateJSON = function(data, idWndw) {
window.tempIdWndw = idWndw

  // convert to VFG3 
  // BF.convertToVFG3(data);
  
  data = translate(data, "$..visible_calc", mapVisible, "calcFunction"); // mapVisible returns a function

  //onPlaceChanged - Google Address
  data = translate(data, "$.pages..onPlaceChanged", onPlaceChanged, "function");

  //onComplete - Form Submit Button
  data = translate(data, "$.pages..onComplete", onComplete, "function");

  // Keep the same snapshot for every discovery pass, including toJSON effects.
  var thestring = JSON.stringify(data);

  // Getters;
  var calcKeys = discoverTranslationKeys(thestring, 'calc');

  calcKeys.forEach(function(key) {
    try {
      if (key != "visible_calc" && key != "validator_calc") {
        // if ( key != "validator_calc") {
        data = translate(data, "$..['" + key + "']", makeCalcFunction, "getter");
      } 
    }
    catch(e) {
      BF.errorThrow(10200, `bfUtilities key: ${key}\nError: ${e}`, 'Error when evaluating calculation field.');
    }
  }, this);

  // Forced calcFunctions - calcf
  calcKeys = discoverTranslationKeys(thestring, 'calcf');
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeCalcFunction, "calcFunction");
  }, this);

  // Functions - _function
  calcKeys = discoverTranslationKeys(thestring, 'function');
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeFunction, "bfFunction");
  }, this);

  // Forced Getters - calcg
  calcKeys = discoverTranslationKeys(thestring, 'calcg');
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeCalcFunction, "getter");
  }, this);

  //_actions;
  calcKeys = discoverTranslationKeys(thestring, 'actions');
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeActionsFunct, "hardFunctionAtKey");
  }, this);

  data = resolveValidatorFunctions(data);

  return data;
};

const resolveValidatorFunctions = function(data) {
  const validators = _.get(window, "VueFormGenerator.validators");
  if (!validators) {
    return data;
  }

  const seenFields = new WeakSet();

  const resolveValidatorEntry = function(entry) {
    return typeof entry === "string" && typeof validators[entry] === "function" ? validators[entry] : entry;
  };

  const resolveField = function(field) {
    if (!field || typeof field !== "object" || seenFields.has(field)) {
      return;
    }

    seenFields.add(field);

    if (typeof field.validator === "string") {
      field.validator = resolveValidatorEntry(field.validator);
    } else if (Array.isArray(field.validator)) {
      field.validator = field.validator.map(resolveValidatorEntry);
    }

    if (Array.isArray(field.fields)) {
      field.fields.forEach(resolveField);
    }
  };

  const resolveContainer = function(container) {
    if (!container || typeof container !== "object") {
      return;
    }

    if (Array.isArray(container)) {
      container.forEach(resolveContainer);
      return;
    }

    if (container.schema && Array.isArray(container.schema.fields)) {
      container.schema.fields.forEach(resolveField);
    }

    if (Array.isArray(container.fields)) {
      container.fields.forEach(resolveField);
    }

    if (Array.isArray(container.pages)) {
      container.pages.forEach(resolveContainer);
    }
  };

  resolveContainer(data);
  return data;
};

// Handles translation
const translate = function(data, filter, hardFunc, meth, key) {
  let paths = formatPaths(translationPaths(data, filter));
  var theFunction;

  for (var i = 0; i < paths.length; i++) {
    var path = paths[i];
    let regex = /\.([a-z0-9A-Z]+\/[a-z0-9A-Z]+)\./g; // regex to add square brackets around paths with '/'
    path = path.replace(regex, (match, p1) => { return `["${p1}"].`; });
    if (
      _.get(data, "model.disableModelCalcs") &&
      path.startsWith("data.model.")
    ) {
      continue;
    }

    // SAMPLE: data.pages[0].schema.fields[0].actions_onRowClick[0].options.path_calc
    let funcText = _.get(data, path.substr(5));

    if (meth == "function") {
      // Just replace the path with the function
      eval(path + " = hardFunc"); // needed?
      let objectPath = path.match(/.*(?=\..*)/)[0];
      _.set(data, objectPath + "." + key, hardFunc);
      continue;
    }

    key = path.match(/([a-zA-Z0-9_ ]+)(?=_[a-z]+$)/)[0];
    let objectPath = path.match(/(?:^data\.)(.*)(?=\..*_)/)[1]; // parent path to the key, without 'data.'

    if (meth == "bfFunction") {
      // Try to make a function
      theFunction = makeFunction(funcText);
      _.set(data, objectPath + "." + key, theFunction);
      continue;
    }

    if (meth == "hardFunctionAtKey") {
      // Puts function in where @ key without _xxxc()
      _.set(data, objectPath + "." + key, hardFunc(funcText));
      continue;
    }

    theFunction = makeCalcFunction(funcText, window.tempIdWndw);
    if (meth == "calcFunction") {
      _.set(data, `${objectPath}.${key}`, theFunction);
    } else if (meth == "getter") {
      // Sticks the function in as a getter
      let object = _.get(data, objectPath);
      object[key + "_fcn"] = theFunction; // since 'this' sees the object, we will stick the _fcn in here
      object["_this"] = Function(`return this`);

      // Map in data so we can ref in calcs, use as function so we don't get circ dep issues
      object["sourceData"] = function() {
        return data;
      };

      Object.defineProperty(object, key, {
        enumerable: true,
        configurable: true,
        // This getter will reference the actual function outside of the defineProperty scope
        // This is needed because the 'this' is the wrong scope inside the getter
        get() {
          try {
            return this[key + "_fcn"]();
          }
          catch (e) {
            if(e.message.includes('is not a function')) return;
          }
        }
      });
      _.set(data, objectPath, object); // Stick the object back in with its getter
    }
  }

  return data;
};

// Returns the list of matching paths
const getPaths = function(data, filter) {
  return formatPaths(jp.paths(data, filter));
};

// Shared legacy formatting; the public API always retains generic JSONPath.
const formatPaths = function(paths) {
  var arrayLength = paths.length;
  var lineResult = [];
  for (var i = 0; i < arrayLength; i++) {
    var line = paths[i];
    for (var j = 0; j < line.length; j++) {
      var term = line[j];
      if (term == "$") {
      } else if (typeof term === "number") {
        lineResult[i] = lineResult[i] + "[" + term + "]";
      } else {
        lineResult[i] =
          lineResult[i] == null ? "data." + term : lineResult[i] + "." + term;
      }
    }
  }
  return lineResult;
};

/************************************ ***
 * Translation Funcions
 *
 *
 **************************************/

// GOOGLE ONPLACECHANGED Function called by google address fieldType
const onPlaceChanged = function(value, placeShort, place, model, schema) {
  model[schema.model + "_google"] = { placeShort, place };
  // model.googleAddress = { placeShort, place };
  return;
};

// BUTTON ONCOMPLETE Function called by submit button element
const onComplete = function(model, schema) {
  // TODO this should change to be an emit
  this.$parent.onComplete();
  return;
};

// VISIBLE_CALC Function swapper
// This returns a function with the value, (expression) hard coded
const mapVisible = function(data, path) {
  return data;
};

// *_CALC Function swapper
// This returns a function with the value, (expression) hard coded for the result
const makeCalcFunction = function(funcText, idWndw) {
  funcText ? 1 : (funcText = "'No Calc Defined!'"); // handles bad calcs
  try {
    return Function(`
      try {
          var app = _.get(window, 'vueapp.$store.state.site.content.app');
          var formSchema = vueapp.$store.getters.getFormSchema(${window.tempIdWndw}) ;
          var model = this.sourceData ? this.sourceData().model : _.get(formSchema, 'model');
          if (app && app.debugCalcs) debugger;
          var result =  ${funcText};
      }
      catch(err) {
          if (app && app.debugCalcs) console.log('error resolving *_calc: ', "${funcText}" , err.message );
          var result = false;
      }   
      return result;`); 
  }
  catch (error) {
    BF.errorThrow(10201, 'Failed to compile *_calc or *_calcf: ' + funcText, error);
  }
};

// ACTIONS_FUNCTION can be added anywhere an action is expected
/// returns a funtion that will queue the passed actions array
const makeActionsFunct = function(actions) {
  const actionsStr = JSON.stringify(actions);
  try {
    return Function(`
      let actions = ${actionsStr};
      let args = arguments;
        actions.forEach(function(action, index) {
            _.set(actions[index], 'options.args', args);
      });
      vueapp.$store.dispatch('ACTIONS_QUEUE', actions);
        return;`);
  }
  catch (err) {
    BF.errorThrow(10202, 'Failed to compile *_actions: ' + actions, err);
  }
};

// Conventional BFFUNCTION
const makeFunction = function(funcText) {
  funcText ? 1 : (funcText = "'No Calc Defined!'"); // handles bad calcs

      // console.log('@bfUtilities makeFunction funcText: ', funcText)
  // try to see if the function compiles
  try {
    return Function(`
    // *** make _function ***
        try {
            var app = _.get(window, 'vueapp.$store.state.site.content.app');
            var formSchema = this.sourceData ? this.sourceData() : _.get(window, 'formGen.formSchema');
            var model = this.sourceData ? this.sourceData().model : _.get(formSchema, 'model');
            if (app.debugFunctions) debugger;
            
            ${funcText};
        }
        catch(err) {
            if (app.debugCalcs) console.log('error resolving *_calc: ', "${funcText}" , err.message );
            var result = false;
            return result;
        }    `);
  }
  catch (err) {
    BF.errorThrow(10203, 'Failed to compile *_function: ' + funcText, err);
  }
};

// **********************************************************
// UUID Generator
const Uuid = function() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

window.uuid = Uuid;

// **********************************************************
// Get QueryParams
const getQueryParams = function() {
  var queryString = window.location.href
    .split("?")
    .slice(1)
    .join("?");
  var qparams = {},
    queries,
    temp,
    i,
    l;
  // Split into key/value pairs
  queries = queryString ? queryString.split("&") : [];
  // Convert the array of strings into an object
  for (i = 0, l = queries.length; i < l; i++) {
    temp = queries[i].split("=");
    qparams[temp[0]] = decodeURIComponent(temp[1]);
  }
  return qparams;
};

export { TranslateJSON, resolveValidatorFunctions, Uuid, getPaths, getQueryParams };
